import { request } from '@/utils/request'
import qs from 'qs'

/**
 * @description 获取用户信息
 */
export function getUserInfo(params: any) {
  return request({
    url: '/zhongcaijie/h5/user/getUserInfo',
    method: 'get',
    params,
  })
}

/**
 * @description 获取企业列表
 */
export function getCompanys(params: any) {
  return request({
    url: '/zhongcaijie/h5/company/getCompanys',
    method: 'get',
    params,
  })
}

/**
 * @description 获取员工信息
 */
export function getEmployeeInfo(params: any) {
  return request({
    url: '/zhongcaijie/h5/useraccount/getH5EmployeeInfo',
    method: 'get',
    params,
  })
}

/**
 * @description 获取企业审核列表
 */
export function getCompanyApprovals(params: any) {
  return request({
    url: '/zhongcaijie/h5/company/getCompanyApprovals',
    method: 'get',
    params,
  })
}

/**
 * @description 切换企业
 */
export function switchCompany(params: any) {
  return request({
    url: '/zhongcaijie/h5/company/switchCompany',
    method: 'post',
    params,
  })
}

/**
 * @description 绑定企业
 */
export function applyCompany(data: any) {
  return request({
    url: '/zhongcaijie/h5/company/applyCompany',
    method: 'post',
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
    data: qs.stringify(data),
  })
}

/**
 * @description 验证企业名称，0 不通过， 1 通过
 */
export function companyNameCheck(params: any) {
  return request({
    url: '/zhongcaijie/h5/company/companyNameCheck',
    method: 'get',
    params,
  })
}

/**
 * @description 获取验证码
 */
export function sendPhoneNumber(params: any) {
  return request({
    url: '/zhongcaijie/h5/company/sendPhoneNumber',
    method: 'get',
    params,
  })
}

/**
 * @description 获取验证码
 */
export function sendUserPhoneNumber(params: any) {
  return request({
    url: '/zhongcaijie/h5/user/sendPhoneNumber',
    method: 'post',
    params,
  })
}

/**
 * @description 获取绑定列表
 */
export function deleteCompany(params: any) {
  return request({
    url: '/zhongcaijie/h5/company/deleteCompany',
    method: 'post',
    params,
  })
}

/**
 * @description 获取我发布的资源信息列表
 */
export function getMyResourceInformations(params: any) {
  return request({
    url: '/resourceinformation/getMyResourceInformations',
    method: 'get',
    params,
  })
}

/**
 * @description 获取我联系的资源信息列表
 */
export function getCollectionResourceInformations(params: any) {
  return request({
    url: '/resourceinformation/getCollectionResourceInformations',
    method: 'get',
    params,
  })
}

/**
 * @description 获取我的关注
 */
export function getUserFollowList(params: any) {
  return request({
    url: '/zhongcaijie/h5/follow/getUserFollowList',
    method: 'get',
    params,
  })
}

/**
 * @description 获取兵器库文件列表
 */
export function getArsenalList(params: any) {
  return request({
    url: '/zhongcaijie/h5/arsenal/getArsenalList',
    method: 'get',
    params,
  })
}

/**
 * @description 获取兵器库类型
 */
export function getArsenalTypeList(params: any) {
  return request({
    url: '/zhongcaijie/h5/arsenal/getArsenalTypeList',
    method: 'get',
    params,
  })
}

/**
 * @description 获取聊天信息
 */
export function getH5ChatRecordDto(params: any) {
  return request({
    url: '/zhongcaijie/h5/chat/getH5ChatRecordDto',
    method: 'get',
    params,
  })
}

/**
 * @description 获取客户顾问(咨询师)
 */
export function getChatAdvisers() {
  return request({
    url: '/zhongcaijie/h5/chat/getChatAdvisers',
    method: 'get',
  })
}

/**
 * @description 获取聊天人员列表
 */
export function getH5ChatListDto(params: any) {
  return request({
    url: '/zhongcaijie/h5/chat/getH5ChatListDto',
    method: 'get',
    params,
  })
}

/**
 * @description 客户发送消息
 */
export function clientSendMsg(params: any) {
  return request({
    url: '/zhongcaijie/h5/chat/clientSendMsg',
    method: 'post',
    params,
  })
}

/**
 * @description 保存企业信息
 */
export function saveCompanyArchives(params: any) {
  return request({
    url: '/zhongcaijie/h5/my/saveCompanyArchives',
    method: 'post',
    data: params,
  })
}

/**
 * @description 获取我的企业详细信息
 */
export function getCustomerArchivesInfo(params: any) {
  return request({
    url: '/zhongcaijie/h5/my/getCustomerArchivesInfo',
    method: 'get',
    params,
  })
}

/**
 * @description 获取外勤单进度节点
 */
export function getFieldListProgressDetail(params: any) {
  return request({
    url: '/zhongcaijie/h5/progress/getFieldListProgressDetail',
    method: 'get',
    params,
  })
}

/**
 * @description 获取外勤单进度列表
 */
export function getFieldListProgress(params: any) {
  return request({
    url: '/zhongcaijie/h5/progress/getFieldListProgress',
    method: 'get',
    params,
  })
}

/**
 * @description 专家邀约
 */
export function addInvitationInterview(params: any) {
  return request({
    url: '/zhongcaijie/h5/interview/addInvitationInterview',
    method: 'post',
    params,
  })
}

/**
 * @description 专家邀约发送验证码
 */
export function sendInvitationPhoneNumber(params: any) {
  return request({
    url: '/zhongcaijie/h5/interview/sendPhoneNumber',
    method: 'post',
    params,
  })
}

/**
 * @description 专家类型
 */
export function getZcjExpertType(params: any) {
  return request({
    url: '/zhongcaijie/h5/alliance/getZcjExpertType',
    method: 'get',
    params,
  })
}

/**
 * @description 添加企业加盟
 */
export function addEnterpriseAlliance(params: any) {
  return request({
    url: '/zhongcaijie/h5/alliance/addEnterpriseAlliance',
    method: 'post',
    params,
  })
}

/**
 * @description 企业加盟验证码
 */
export function allianceSendPhoneNumber(params: any) {
  return request({
    url: '/zhongcaijie/h5/alliance/sendPhoneNumber',
    method: 'post',
    params,
  })
}

/**
 * @description 获取素材列表
 */
export function getSourceMaterialList(params: any) {
  return request({
    url: '/zhongcaijie/h5/material/getZcjSourceMaterialList',
    method: 'get',
    params,
  })
}

/**
 * @description 获取素材类型
 */
export function getSourceMaterialType() {
  return request({
    url: '/zhongcaijie/h5/material/getZcjSourceMaterialType',
    method: 'get',
  })
}

/**
 * @description 老板查账
 */
export function getFinanceSubjectBalance(params: any) {
  return request({
    url: '/zhongcaijie/h5/subjectBalance/getFinanceSubjectBalance',
    method: 'get',
    params,
  })
}

/**
 * @description 财务概要表
 */
export function getCurrentPeriodFinanceSubjectBalance(params: any) {
  return request({
    url: '/zhongcaijie/h5/subjectBalance/getCurrentPeriodFinanceSubjectBalance',
    method: 'get',
    params,
  })
}

/**
 * @description 查询客户利润情况
 */
export function getCustomerProfitSituation(params: any) {
  return request({
    url: '/zhongcaijie/h5/finance/getCustomerProfitSituation',
    method: 'get',
    params,
  })
}

/**
 * @description 获取资产负债信息
 */
export function getAssetLiability(params: any) {
  return request({
    url: '/zhongcaijie/h5/finance/getAssetLiability',
    method: 'get',
    params,
  })
}

/**
 * @description 获取资产负债信息
 */
export function getProfit(params: any) {
  return request({
    url: '/zhongcaijie/h5/finance/getProfit',
    method: 'get',
    params,
  })
}

/**
 * @description 获取应收,应付，预付，预收项目信息
 */
export function getSubjectBalanceH5(params: any) {
  return request({
    url: '/zhongcaijie/h5/subjectBalance/getSubjectBalanceH5',
    method: 'get',
    params,
  })
}

/**
 * @description 获取应收,应付项目信息
 */
export function getSubjectBalanceH5Query(params: any) {
  return request({
    url: '/zhongcaijie/h5/subjectBalance/getSubjectBalanceH5Query',
    method: 'get',
    params,
  })
}

/**
 * @description 获取应收,应付，预付，预收项目信息
 */
export function getSubjectBalanceH51(params: any) {
  return request({
    url: '/zhongcaijie/h5/subjectBalance/getSubjectBalanceH5',
    method: 'get',
    params,
  })
}

/**
 * @description 获取应收,应付项目信息
 */
export function getSubjectBalanceH5Query1(params: any) {
  return request({
    url: '/zhongcaijie/h5/subjectBalance/getSubjectBalanceH5Query',
    method: 'get',
    params,
  })
}

/**
 * @description 获取纳税信息
 */
export function getCustoemrReplyLetter(params: any) {
  return request({
    url: '/zhongcaijie/h5/finance/getCustoemrReplyLetter',
    method: 'get',
    params,
  })
}

/**
 * @description 解除绑定信息
 */
export function unbindCompany(params: any) {
  return request({
    url: '/zhongcaijie/h5/company/unbindCompany',
    method: 'post',
    params,
  })
}

/**
 * @description 查询企业下的用户
 */
export function getZcjCompanyUsers(params: any) {
  return request({
    url: '/zhongcaijie/h5/company/getZcjCompanyUsers',
    method: 'get',
    params,
  })
}

/**
 * @description 邀请注册验证码
 */
export function inviteeSendPhoneNumber(params: any) {
  return request({
    url: '/zhongcaijie/h5/invitee/sendPhoneNumber',
    method: 'get',
    params,
  })
}

/**
 * @description 注册（添加邀请记录）
 */
export function addInvitee(params: any) {
  return request({
    url: '/zhongcaijie/h5/invitee/addInvitee',
    method: 'post',
    params,
  })
}

// 营业执照信息
export function getCustomerBusinessLicense() {
  return request({
    url: '/zhongcaijie/h5/my/getCustomerBusinessLicense',
  })
}

/**
 * @description 根据人员ID与人员类型获取他的手机号码
 */
export function getPhoneByStaffIdAndType(params: any) {
  return request({
    url: '/zhongcaijie/h5/chat/getPhoneByStaffIdAndType',
    method: 'get',
    params,
  })
}

/**
 * @description 绑定手机号
 */
export function boundPhone(params: any) {
  return request({
    url: '/zhongcaijie/h5/user/boundPhone',
    method: 'post',
    params,
  })
}

// 授权员工电话
export function authorizationPhone(params: any) {
  return request({
    url: '/zhongcaijie/h5/chat/authorizationPhone',
    method: 'get',
    params,
  })
}

// 阅读量，下载量，收藏量+1
export function addUseCount(params: any) {
  return request({
    url: '/zhongcaijie/h5/arsenal/addUseCount',
    method: 'post',
    params,
  })
}

// 获取未读消息数量
export function getUnReadNum() {
  return request({
    url: '/zhongcaijie/h5/chat/getUnReadNum',
    method: 'get',
  })
}

// 获取申请员工验证码
export function sendEmployeehoneNumber(params: any) {
  return request({
    url: '/zhongcaijie/h5/employee/sendPhoneNumber',
    method: 'get',
    params,
  })
}

// 申请员工
export function applyEmployee(params: any) {
  return request({
    url: '/zhongcaijie/h5/employee/applyEmployee',
    method: 'post',
    params,
  })
}

// 获取所属公司列表
export function getEmployeeCompanyList() {
  return request({
    url: '/zhongcaijie/h5/employee/getEmployeeCompanyList',
    method: 'get',
  })
}

// 获取未使用权益包数量
export function getCountUserPersonalHome() {
  return request({
    url: '/zhongcaijie/h5/user/countUserPersonalHome',
    method: 'get',
  })
}

// 领取赠送的权益包
export function receiveGivePackage(params: any) {
  return request({
    url: '/zhongcaijie/h5/rightsPackage/receiveGivePackage',
    method: 'post',
    params,
  })
}

// 修改员工二维码
export function editUserWxQrCode(params: any) {
  return request({
    url: '/zhongcaijie/h5/employee/editUserWxQrCode',
    method: 'post',
    params,
  })
}

// 获取助力素材
export function getInformationList(params: any) {
  return request({
    url: '/zhongcaijie/h5/helpMaterial/getInformationList',
    method: 'get',
    params,
  })
}

// 订单中心列表
export function getH5QueryGoodsOrderList(params: any) {
  return request({
    url: '/zhongcaijie/goods/order/queryGoodsOrderList',
    method: 'get',
    params,
  })
}

// 认领素材
export function claimMaterial(params: any) {
  return request({
    url: '/zhongcaijie/h5/helpMaterial/claimMaterial',
    method: 'post',
    params: params,
  })
}

// 订单中心详情
export function getH5QueryGoodsOrderDetails(params: any) {
  return request({
    url: '/zhongcaijie/goods/order/queryGoodsOrderDetails',
    method: 'get',
    params,
  })
}

// 活动积分商城列表
export function getIntegralGoodsList(params: any) {
  return request({
    url: '/zhongcaijie/wx/integralGoodsOrder/getIntegralGoodsList',
    method: 'get',
    params,
  })
}

// 活动积分详情
export function getIntegralGoods(params: any) {
  return request({
    url: '/zhongcaijie/wx/integralGoodsOrder/getIntegralGoods',
    method: 'get',
    params,
  })
}

// 获取分享的用户信息（联系号码、二维码）
export function getShareUserInfo(params: any) {
  return request({
    url: '/zhongcaijie/h5/employee/getEmployeeInfo',
    method: 'get',
    params,
  })
}

// 获取商城首页积分信息
export function getMyInviteActivity() {
  return request({
    url: '/zhongcaijie/wx/activity/getMyInviteActivity',
    method: 'get',
  })
}

// 活动积分兑换
export function addIntegralGoodsOrder(params: any) {
  return request({
    url: '/zhongcaijie/wx/integralGoodsOrder/addIntegralGoodsOrder',
    method: 'post',
    params,
  })
}

// 积分明细/积分记录
export function getUserActivityIntegralRecord(params: any) {
  return request({
    url: '/zhongcaijie/wx/integralGoodsOrder/getUserActivityIntegralRecord',
    method: 'get',
    params,
  })
}

// 注册/更新用户信息
export function updateWxUser(data: any) {
  return request({
    url: '/zhongcaijie/h5/user/updateWxUser',
    method: 'post',
    headers: { 'content-type': 'application/json' },
    data,
  })
}
